module.exports = __webpack_public_path__ + "img/img_banner_duikang.95204930.png";